import type { ITypo } from './Typo';

import Typo from './Typo';

export type { ITypo };
export default Typo;
